import "./utils";
import "../css/main.scss";
import "./events/main";
import "./popups/main";

// 1. Core components (execute immediately)
import "./components/main";

// Content Saving
import { initSaveContent } from "./modules/save-content";
initSaveContent();

/**
 * Dynamic Module Loading Pattern
 * Matches elements presence to avoid loading unnecessary code
 */

// TOC (Table of Contents)
if (document.querySelector(".toc") || document.querySelector(".toc-mobile-bar")) {
    import(/* webpackChunkName: "toc" */ "./toc/main").catch(err => console.error("TOC module failed:", err));
}

// Sanctum Archive
if (document.getElementById("archive-sanctums")) {
    import(/* webpackChunkName: "archive-sanctums" */ "./sanctum-archive/main").catch(err => console.error("Sanctum Archive module failed:", err));
}

if (document.querySelector("[data-sanctum-post-id]")) {
    import(/* webpackChunkName: "sanctum-view-tracker" */ "./components/sanctum-view-tracker")
        .then(({ default: initSanctumViewTracker }) => initSanctumViewTracker())
        .catch(err => console.error("Sanctum view tracker failed:", err));
}

// Article Archive
if (document.getElementById("archive-articles")) {
    import(/* webpackChunkName: "article-archive" */ "./article-archive/main").catch(err => console.error("Article Archive module failed:", err));
}

// Third Testament Archive & Single
if (document.getElementById("archive-testament") || document.getElementById("single-third-testament")) {
    import(/* webpackChunkName: "archive-testament" */ "./components/third-testament/archive-testament").then(({ default: initArchiveTestament }) => {
        initArchiveTestament();
    }).catch(err => console.error("Testament module failed:", err));
}

// Symphony Search
if (document.querySelector(".sanctum-symphony-content")) {
    import(/* webpackChunkName: "symphony" */ "./sanctum-symphony/symphony-content").then(({ default: initSymphony }) => {
        initSymphony();
    }).catch(err => console.error("Symphony module failed:", err));
}

// Testament Symphony
if (document.querySelector(".testament-symphony-content")) {
    import(/* webpackChunkName: "testament-symphony" */ "./testament-symphony/symphony").then(({ default: initTestamentSymphony }) => {
        initTestamentSymphony();
    }).catch(err => console.error("Testament Symphony module failed:", err));
}

// Topics List
if (document.querySelector(".sanctum-topic-content")) {
    import(/* webpackChunkName: "topics" */ "./sanctum-topics/main").catch(err => console.error("Topics module failed:", err));
}


// Home Hero
if (document.querySelector('.hero')) {
    import(/* webpackChunkName: 'hero-motion' */ './components/home/hero-motion')
        .then(({ default: initHeroMotion }) => initHeroMotion(document.querySelector('.hero')))
        .catch(err => console.error('Hero motion module failed:', err));
}

if (document.querySelector('[data-hero]')) {
    import(/* webpackChunkName: 'home-hero' */ './components/home/hero').then(({ default: Hero }) => {
        document.querySelectorAll('[data-hero]').forEach((root) => new Hero(root));
    }).catch(err => console.error('Home hero module failed:', err));
}
